package org.example.site_web.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Animation
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.height
import com.varabyte.kobweb.compose.dom.GenericTag
import com.varabyte.kobweb.compose.dom.svg.Circle
import com.varabyte.kobweb.compose.ui.Modifier

import com.varabyte.kobweb.compose.dom.svg.Turbulence
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.IconRenderStyle
import com.varabyte.kobweb.silk.components.icons.createIcon
import org.jetbrains.compose.web.css.em
import com.varabyte.kobweb.compose.dom.svg.Line
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Polygon
import com.varabyte.kobweb.compose.dom.svg.Rect
import com.varabyte.kobweb.compose.dom.svg.SVGAspectRatioScale
import com.varabyte.kobweb.compose.dom.svg.SVGFillRule
import com.varabyte.kobweb.compose.dom.svg.SVGFillType
import com.varabyte.kobweb.compose.dom.svg.SVGStrokeLineCap
import com.varabyte.kobweb.compose.dom.svg.SVGStrokeType
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.dom.svg.Text
import com.varabyte.kobweb.compose.dom.svg.ViewBox
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.Element
import org.w3c.dom.svg.SVGElement
import org.w3c.dom.svg.SVGGraphicsElement
import org.w3c.dom.svg.SVGSVGElement
import kotlin.math.*


//import androidx.compose.runtime.Composable
//import com.varabyte.kobweb.compose.ui.Modifier
//import com.varabyte.kobweb.compose.ui.modifiers.setVariable
//import com.varabyte.kobweb.silk.components.forms.Button
//import com.varabyte.kobweb.silk.components.forms.ButtonVars
//import com.varabyte.kobweb.silk.components.graphics.Canvas2d
//import com.varabyte.kobweb.silk.components.graphics.ONE_FRAME_MS_60_FPS
//import org.jetbrains.compose.web.css.em
//import org.jetbrains.compose.web.dom.Text
//import org.w3c.dom.CanvasLineCap
//import org.w3c.dom.CanvasState
//
////fun CanvasState.save(block: () -> Unit) {
////    save()
////    block()
////    restore()
////}
//



@Composable
fun AnimEngrenage(modifier: Modifier = Modifier, frame: Double = 0.0)
{
    Svg(Modifier.fillMaxSize().toAttrs(){
        stroke(Colors.White)
        strokeWidth(1.px)
        strokeLineCap(SVGStrokeLineCap.Round)
        fill(SVGFillType.CurrentColor)
        viewBox(0,0,100,100)
    }) {

        val entraxe = 19.5
        val tx = 25
        //Gros pignon
        Path {
            d(
                "m 13.5142,-2.15946 2.1905,0.50883 2.1898,1.37488 v 0.5515 l -2.1898,1.37488 -2.1905,0.50883 -0.29,1.3645 1.7941,1.35578 1.4413,2.14671 -0.2243,0.50381 -2.5598,0.36532 -2.208,-0.42608 -0.8199,1.12856 1.0875,1.96824 0.4436,2.5474 -0.4098,0.369 L 9.28181,12.7753 7.43799,11.488 6.22989,12.1855 6.42284,14.4259 5.79196,16.9335 5.26746,17.1039 3.28317,15.4461 2.12235,13.5201 0.73501,13.6659 0,15.7912 l -1.59625,2.0341 -0.54847,-0.0576 -1.13845,-2.3216 -0.27708,-2.2316 -1.32671,-0.4311 -1.53588,1.6425 -2.28561,1.2091 -0.47761,-0.2758 -0.09575,-2.5839 0.65455,-2.1514 -1.03668,-0.9334 -2.07116,0.8758 -2.5798,0.1749 -0.3241,-0.4462 0.9635,-2.39942 1.473,-1.69916 -0.5674,-1.27438 -2.2484,-0.0423 -2.4278,-0.88954 -0.1147,-0.53944 1.8561,-1.80013 2.0368,-0.95314 v -1.39498 l -2.0368,-0.95314 -1.8561,-1.80013 0.1147,-0.53944 2.4278,-0.88954 2.2484,-0.0423 0.5674,-1.27438 -1.473,-1.69916 -0.9635,-2.39942 0.3241,-0.4462 2.5798,0.1749 2.07116,0.8758 1.03668,-0.9334 -0.65455,-2.1514 0.09575,-2.5839 0.47761,-0.2758 2.28561,1.2091 1.53588,1.6425 1.32671,-0.4311 0.27708,-2.2316 1.13845,-2.3216 0.54847,-0.0576 1.59625,2.0341 0.73501,2.1253 1.38734,0.1458 1.16082,-1.926 1.98429,-1.6578 0.5245,0.1704 0.63088,2.5076 -0.19295,2.2404 1.2081,0.6975 1.84382,-1.2873 2.48709,-0.7074 0.4098,0.369 -0.4436,2.5474 -1.0875,1.96824 0.8199,1.12856 2.208,-0.42608 2.5598,0.36532 0.2243,0.50381 -1.4413,2.14671 -1.7941,1.35578 z"
            )
            transform {
                rotate(frame,tx,tx)
                translate(tx,tx)
            }
            fill(SVGFillType.None)
        }
        Circle {
            cx(0)
            cy(0)
            r(5.29)
            transform {
                //rotate(tx,tx,frame)
                translate(tx,tx)
            }
            fill(SVGFillType.None)
        }

        //Petit pignon
        Path {
            d(
                "m6.11994,-1.56334 0.94676,-0.24184 1.19342,0.16214 2.26618,1.48859 v 0.3089 L 8.26012,1.64304 7.0667,1.80518 6.11994,1.56334 5.4329,3.22201 6.27337,3.72045 7.00259,4.67898 7.55243,7.33401 7.33401,7.55243 4.67898,7.00259 3.72045,6.27337 3.22201,5.4329 1.56334,6.11994 1.80518,7.0667 1.64304,8.26012 0.15445,10.5263 h -0.3089 L -1.64304,8.26012 -1.80518,7.0667 -1.56334,6.11994 -3.22201,5.4329 -3.72045,6.27337 -4.67898,7.00259 -7.33401,7.55243 -7.55243,7.33401 -7.00259,4.67898 -6.27337,3.72045 -5.4329,3.22201 -6.11994,1.56334 -7.0667,1.80518 -8.26012,1.64304 -10.5263,0.15445 v -0.3089 l 2.26618,-1.48859 1.19342,-0.16214 0.94676,0.24184 0.68704,-1.65867 -0.84047,-0.49844 -0.72922,-0.95853 -0.54984,-2.65503 0.21842,-0.21842 2.65503,0.54984 0.95853,0.72922 0.49844,0.84047 1.65867,-0.68704 -0.24184,-0.94676 0.16214,-1.19342 1.48859,-2.26618 h 0.3089 l 1.48859,2.26618 0.16214,1.19342 -0.24184,0.94676 1.65867,0.68704 0.49844,-0.84047 0.95853,-0.72922 2.65503,-0.54984 0.21842,0.21842 -0.54984,2.65503 -0.72922,0.95853 -0.84047,0.49844 z"
            )
            transform {
                rotate(frame*(-6.5/3.25),tx+entraxe,tx+entraxe)
                translate(tx+entraxe,tx+entraxe )
            }
            fill(SVGFillType.None)
        }

        Circle {
            cx(0)
            cy(0)
            r(2.645)
            transform {
                //rotate(tx,tx,frame)
                translate(tx + entraxe,tx + entraxe)
            }
            fill(SVGFillType.None)
        }
    }

}
